import React from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-rte/lib/RichTextEditor';
import { windowUndefined } from '../../../../../../../helpers/serverRenderingUtils';

import styles from './RichTextEditor.sass';

const TOOLBAR_CONFIG = {
  // Optionally specify the groups to display (displayed in the order listed).
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' },
  ],
};

class CustomRichTextEditor extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    maxCharacterLength: PropTypes.number.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: null,
  };

  constructor(props) {
    super(props);
    // here we create the empty state
    let value = RichTextEditor.createEmptyValue();
    // if the redux-form field has a value
    if (props.value) {
      value = RichTextEditor.createValueFromString(props.value, 'html');
    }
    this.state = {
      value,
      currentCharacterLength: value.toString('html'),
    };
    this.parser = windowUndefined() ? null : new DOMParser();
  }

  componentDidUpdate(prevProps) {
    const { value: propValue } = this.props;
    const { value: stateValue } = this.state;
    const { value: prevPropValue } = prevProps;

    // for the redux form we have to check to see if the value has updated
    if (
      prevPropValue !== propValue &&
      propValue !== stateValue.toString('html')
    ) {
      this.updateRteState();
    }
  }

  updateRteState = () => {
    const { value } = this.props;
    this.setState({
      value: RichTextEditor.createValueFromString(value, 'html'),
    });
  };

  onChange = newValue => {
    const { value: currentValue } = this.state;
    const { onChange, maxCharacterLength } = this.props;
    const newValueHtmlString = newValue.toString('html');
    const saveValue =
      newValueHtmlString.length <= maxCharacterLength ? newValue : currentValue;
    let saveValueHtml = saveValue.toString('html');

    // check for any anchor tags
    const hasAnchors = /href=("|')(.*?)("|')/g.test(saveValueHtml);
    if (hasAnchors) {
      const dom = this.parser.parseFromString(saveValueHtml, 'text/html');
      const links = dom && dom.links;
      if (links.length > 0) {
        for (const link of links) {
          const href = link.getAttribute('href');
          // check if anchor tag contains protocol, mailto, or tel href
          const isValid = /\/\/|mailto:|tel:/.test(href);
          if (!isValid) {
            // add relative protocol if missing in url
            link.setAttribute('href', `//${href}`);
          }
        }
        saveValueHtml = dom.body.innerHTML;
      }
    }

    this.setState({
      value: saveValue,
      currentCharacterLength: saveValueHtml.length,
    });
    if (onChange) {
      onChange(saveValueHtml);
    }
  };

  handleBeforeInput = chars => {
    const { currentCharacterLength } = this.state;
    const { maxCharacterLength } = this.props;
    return currentCharacterLength + chars.length <= maxCharacterLength
      ? null
      : 'handled';
  };

  render() {
    const { value } = this.state;
    const {
      placeholder,
      className: classNameProp,
      onFocus,
      onBlur,
    } = this.props;

    let className = styles.root;
    if (classNameProp) {
      className = `${className} ${classNameProp}`;
    }
    return (
      <div className={className}>
        <RichTextEditor
          onChange={this.onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          handleBeforeInput={this.handleBeforeInput}
          toolbarConfig={TOOLBAR_CONFIG}
          value={value}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export { CustomRichTextEditor as RichTextEditor };
